import React from 'react';
import { sentenceCase } from 'change-case';
import { PageHeader, Row, Col } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import DEFAULT_VIEW from '../../config/routing';

interface ClientDetailCardProps {
    data: {
        id: number | string;
        name: string;
        stuartClientId: string | null;
        storeId: string | undefined;
        status: string;
    };
}

const ClientDetailCard: React.FC<ClientDetailCardProps> = (props: ClientDetailCardProps): React.ReactElement => {
    const {
        data: { id, name, stuartClientId, storeId, status },
    } = props;

    const clientDetailItems: { key: string; data: any }[] = [
        { key: 'name', data: name },
        { key: 'status', data: status },
        { key: 'stuartClientId', data: stuartClientId },
        { key: 'storeId', data: storeId },
    ];

    return (
        <div className="shadow-sm py-2">
            <PageHeader
                className="site-page-header py-2 justify-content-end"
                title={<p className="h5 m-0">Client details</p>}
                extra={[
                    <Link
                        key="link-to-client-section"
                        id="link-to-client-section"
                        to={`${DEFAULT_VIEW}/clients/detail/${id}`}
                        className="w-100 d-flex align-items-center"
                        rel="noopener noreferrer"
                        title="View on client section"
                    >
                        <ExportOutlined className="mr-2" />
                        View on client section
                    </Link>,
                ]}
            />
            <div className="px-4">
                {clientDetailItems.map(({ key, data }) => (
                    <Row key={key}>
                        <Col span={12}>{`${sentenceCase(key)}:`}</Col>
                        <Col span={12} className="text-secondary" style={{ wordBreak: 'break-word' }}>
                            {data}
                        </Col>
                    </Row>
                ))}
            </div>
        </div>
    );
};

export default ClientDetailCard;
